import axios from "axios";
import {API_URL} from "../environment";

if (localStorage.getItem("token")) {
  axios.defaults.headers.common["Authorization"] = localStorage.getItem("token");
}

if (localStorage.getItem("user")) {
  let user = localStorage.getItem("user");
  // console.log({user})
  // if (user)
  axios.defaults.headers.common["user"] = user
  // else
  //   axios.defaults.headers.common["user"] = ''

}

export default class HttpService {
  static setToken = (token) => {
    axios.defaults.headers.common["Authorization"] = token;
  };
  static setUser = (user) => {
    axios.defaults.headers.common["user"] = user;
  };

  static removeUser = () => {
    axios.defaults.headers.common["user"] = '';
  };

  get = (url, params) => axios.get(`${API_URL}/${url}`, {params});

  post = (url, data) => axios.post(`${API_URL}/${url}`, data);

  put = (url, data, params) => axios.put(`${API_URL}/${url}`, data, {params});

  patch = (url,  params) => axios.patch(`${API_URL}/${url}`,  params);

  delete = (url, params) => axios.delete(`${API_URL}/${url}`, {params});

  gets = (url, params) => axios.get(`${API_URL}/${url}`, {params});

  // patch = (url, params) => axios.patch(`${API_URL}/${url}`, {params});

  addressget = (params) => axios.get(`https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?api_key=ak_jc635mjv12swIsWCiEJWOAiDG0W84&query=${params}`);
}
